import ColorModeSwitcher from './ColorModeSwitcher.component';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ColorModeSwitchContainer() {
  return _jsx(ColorModeSwitcher, {});
}